export default __webpack_public_path__ + "static/media/purple-bg.c9d89fbd.svg";